import React from 'react';
import { Form, Icon, Message} from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivelT = props => {
  return (
    <option dato1={props.elemento.codigoTipoDoc} value={props.elemento.numeroDocum}>{props.elemento.descrRecurso}</option>
  )
};

const ListaT = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1DetalleT = list.map((elemento, _id) => <DetalleNivelT elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tecnico" id="miListaT" value={permiteUpdate?argsDocum.numeroDocumT:idLista.numeroDocumT} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1DetalleT}
      </select>
    </div>
  )
};

const DetalleNivelR = props => {
  return (
    <option dato1={props.elemento.codigoTipoDoc} value={props.elemento.numeroDocum}>{props.elemento.descrRecurso}</option>
  )
};

const ListaR = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1DetalleR = list.map((elemento, _id) => <DetalleNivelR elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="recaudo" id="miListaR" value={permiteUpdate?argsDocum.numeroDocumR:idLista.numeroDocumR} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1DetalleR}
      </select>
    </div>
  )
};

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoDpto} value={props.elemento._id}>{props.elemento.descrDpto}</option>
  )
};

const Lista = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista" value={permiteUpdate?argsDocum._id:idLista._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivel3 = props => {
  return(
    <option dato1={props.elemento.codigoCiudad} value={props.elemento.codigoCiudad}>{props.elemento.nombreCiudad}</option>
  )
}

const DetalleNivel2 = ({styles, idLista, argsDocum, elemento, permiteUpdate, handleChange}) => {
  const Nivel3Detalle = elemento.ciudades.map((elemento, i) => <DetalleNivel3 styles={styles} elemento={elemento} key={i} />);
  return (
    <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" value={permiteUpdate?argsDocum.codigoCiudad:idLista.codigoCiudad} onChange={(ev)=>handleChange(ev, argsDocum)}>
      {Nivel3Detalle}
    </select>
  )
};

const ListaCi = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  var Nivel2Detalle = []
  list.forEach((elemento, _id) => {
    if(elemento._id===idLista._id){
      let niv2Det = []
      niv2Det.push(elemento)
      Nivel2Detalle = niv2Det.map((elemento, _id) => <DetalleNivel2 styles={styles} elemento={elemento} key={elemento._id} permiteUpdate={permiteUpdate} idLista={idLista} argsDocum={argsDocum} handleChange={handleChange}/>);
    }
  })
  return(
    <div>
      {Nivel2Detalle}
    </div>
  )
};

//
const DetalleNivel5 = props => {
  return(
    <option dato1={props.elemento.codigoZona} value={props.elemento.codigoZona}>{props.elemento.nombreZona}</option>
  )
}

const DetalleNivel4 = ({styles, idLista, argsDocum, elemento, permiteUpdate, handleChange}) => {
  // console.log(elemento)
  var Nivel5Detalle = []
  var niv5Det = []
  elemento.zonas.forEach((elemento1, i) => {
    if(elemento1.codigoZona){niv5Det.push(elemento1)}
  })
  Nivel5Detalle = niv5Det.map((elemento, i) => <DetalleNivel5 styles={styles} elemento={elemento} key={i} />);
  return (
    <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista2" value={permiteUpdate?argsDocum.codigoZona:idLista.codigoZona} onChange={(ev)=>handleChange(ev, argsDocum)}>
      {Nivel5Detalle}
    </select>
  )
};

const ListaZo = ({styles, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  var Nivel4Detalle = []
  list.forEach((elemento, _id) => {
    if(elemento._id===idLista._id){
      elemento.ciudades.forEach((elemento1, i) => {
        if(elemento1.codigoCiudad===idLista.codigoCiudad){
          let niv4Det = []
          niv4Det.push(elemento)
          Nivel4Detalle = niv4Det.map((elemento, _id) => <DetalleNivel4 styles={styles} elemento={elemento1} key={elemento._id} permiteUpdate={permiteUpdate} idLista={idLista} argsDocum={argsDocum} handleChange={handleChange}/>);
        }
      })
    }
  })
  return(
    <div>
      {Nivel4Detalle}
    </div>
  )
};
//

class VerBarr2 extends React.Component {
  state={
    argsDocum: {codigoBarrio: this.props.idLista.codigoBarrio,
                nombreBarrio: this.props.idLista.nombreBarrio,
                nombreBarrioAnt: this.props.idLista.nombreBarrio,
                numeroDocumT: this.props.idLista.numeroDocumT,
                codigoTipoDocT: this.props.idLista.codigoTipoDocT,
                descrRecursoT: this.props.idLista.descrRecursoT,
                numeroDocumR: this.props.idLista.numeroDocumR,
                codigoTipoDocR: this.props.idLista.codigoTipoDocR,
                descrRecursoR: this.props.idLista.descrRecursoR,
                codigoZona: this.props.idLista.codigoZona,
                nombreZona: this.props.idLista.nombreZona,
                codigoCiudad: this.props.idLista.codigoCiudad,
                nombreCiudad: this.props.idLista.nombreCiudad,
                codigoDpto: this.props.idLista.codigoDpto,
                descrDpto: this.props.idLista.descrDpto,
                _id: this.props.idLista._id},
    confirmaAct: false,
    open: false
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      // console.log(ev.target.name)
      // console.log(ev.target)
      if(ev.target.name !== "codigoBarrio"){
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "dpto"){
          //No se permite modificar el departamento => se comentan las lineas siguientes
                  // argsDocum['_id'] = ev.target.value
                  // var miLista = document.getElementById("miLista");
                  // argsDocum['descrDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
        }else{
          if(ev.target.name === "tecnico"){
            argsDocum['numeroDocumT'] = ev.target.value
            let miLista = document.getElementById("miListaT");
            argsDocum['descrRecursoT'] = miLista.options[miLista.selectedIndex].text
            argsDocum['codigoTipoDocT'] = miLista.options[miLista.selectedIndex].attributes[0].value
          }else{
            if(ev.target.name === "recaudo"){
              argsDocum['numeroDocumR'] = ev.target.value
              let miLista = document.getElementById("miListaR");
              argsDocum['descrRecursoR'] = miLista.options[miLista.selectedIndex].text
              argsDocum['codigoTipoDocR'] = miLista.options[miLista.selectedIndex].attributes[0].value
            }else{
              argsDocum[ev.target.name] = ev.target.value 
            }
          }
        }
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, confirmaAct, open} = this.state;

    let lisTEC = this.props.list1
    lisTEC = lisTEC.filter(elemento => elemento.tiporec.areaAprovech==='TECNICA')
    let lisREC = this.props.list1
    lisREC = lisREC.filter(elemento => elemento.tiporec.areaAprovech==='RECAUDO')

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Zona
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Código</label>
                    <input style={this.props.styles.input} autoComplete="off" name="codigoBarrio" id="codigoBarrio" value={argsDocum.codigoBarrio} onChange={this.handleChange} placeholder='Código' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoBarrio'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <input style={this.props.styles.input} autoComplete="off" name="nombreBarrio" id="nombreBarrio" value={this.props.permiteUpdate?argsDocum.nombreBarrio:this.props.idLista.nombreBarrio} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'nombreBarrio'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Area de aprovechamiento - TECNICA</label>
                    <ListaT styles={this.props.styles} list={lisTEC} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Area de aprovechamiento - RECAUDO</label>
                    <ListaR styles={this.props.styles} list={lisREC} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>   
                    <label style={this.props.styles.label}>Departamento</label>
                    <Lista list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Ciudad</label>
                    <ListaCi list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Zona</label>
                    <ListaZo list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>

                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>

                  {
                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerBarr2
